module.exports = {
  "/": {
    "success": {
      "index page loaded": [
        "INDEX_LOAD"
      ]
    }
  },
  "/:slug": {
    "success": {
      "index page loaded": [
        "INDEX_LOAD"
      ]
    }
  }
};